import { Link } from '@gassan-ui'
import { PreOwnedWatchesContent } from '@lib/kontent/navigation-helpers/get-pre-owned-watches-content'
import NextLink from 'next/link'
import { FC } from 'react'
import { HeaderLinkColumn } from '../link-column'
import { HeaderImageColumn } from '../image-column'

type HeaderShopMenuWatchesProps = PreOwnedWatchesContent

export const HeaderShopMenuWatches: FC<HeaderShopMenuWatchesProps> = ({
  linkList,
  imageLinkFirstColumn,
  imageLinkSecondColumn,
}) => {
  return (
    <>
      <HeaderLinkColumn
        title={linkList.title}
        readMoreLink={
          linkList.viewMore && (
            <NextLink href={linkList.viewMore.url} passHref>
              <Link variant="blue">{linkList.viewMore.label}</Link>
            </NextLink>
          )
        }
        links={linkList.links}
        linkSpace="regular"
      />
      {imageLinkFirstColumn && <HeaderImageColumn {...imageLinkFirstColumn} />}
      {imageLinkSecondColumn && <HeaderImageColumn {...imageLinkSecondColumn} showOnlyOnXlarge />}
    </>
  )
}
